import request from '../utils/request'
export const listStudents = params => request.get('/students', { params })
export const getStudent = id => request.get(`/students/${id}`)
export const createStudent = data => request.post('/students', data)
export const updateStudent = (id, data) => request.patch(`/students/${id}`, data)
export const deleteStudent = id => request.delete(`/students/${id}`)
export const updateStudentStatus = (id, data) => request.patch(`/students/${id}/status`, data)
export const assignStudentClass = (id, classId) => request.post(`/students/${id}/assign-class`, { classId })
export const generateInviteCode = id => request.post(`/students/${id}/invite-code`)
export const adjustStudentPoints = (id, data) => request.post(`/students/${id}/points`, data)
export const listStudentPointRecords = (id, params) => request.get(`/students/${id}/point-records`, { params })
export const adjustStudentRemainingDays = data => request.post('/students/remaining-days/batch-adjust', data)
export const sendStudentCareDayReminder = id => request.post(`/students/${id}/care-day-reminder`)
